export default __webpack_public_path__ + "static/media/trampolim.3acbc7c9.png";